import Vue from "vue";
import { authHTTP } from "@/services/axios.service";
import store from "@/store";
import { VueOfflineStorage } from "vue-offline";
import { HandleFilters, MutateFilter } from "@/services/filters.service";
import { handleError } from "@/functions/handleError.function";

// initial state
const state = {
  questions: {},
  questionList: [],
  topics: [],
  filters: {},
  pages: {},
  error: {}
};
const getters = {
  loading: state => {
    return state.loading;
  },
  search: state => {
    return state.filters.search;
  },
  filters: state => {
    return state.filters;
  },
  questionList: state => {
    return state.questionList;
  },
  question: state => id => {
    var result = state.questions[id];
    if (!result) {
      return {};
    } else {
      return result;
    }
  },
  topics: state => {
    return state.topics;
  },
  actions: state => {
    return state.actions;
  },
  pages: state => {
    return state.pages;
  },
  error: state => {
    return state.error;
  }
};
const actions = {
  getQuestionList(context) {
    mutations.clearErrors();
    const pageSize = store.getters["core/pageSize"];
    var filterString = HandleFilters(state.filters, pageSize);
    authHTTP
      .get("questions/" + filterString)
      .then(function(response) {
        state.questionList = response.data.results;
        var pages = Object.assign({}, response.data);
        delete pages.results;
        Vue.set(state.pages, "questionList", pages);
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
      });
  },
  getQuestion(context, payload) {
    mutations.clearErrors();
    authHTTP
      .get("questions/" + payload.id + "/")
      .then(function(response) {
        // Vue.set(object, propertyName, value)
        Vue.set(state.questions, payload.id, response.data);
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
      });
  },
  getTopics(context) {
    mutations.clearErrors();
    authHTTP
      .get("topics/?is_active=true")
      .then(function(response) {
        state.topics = response.data;
        VueOfflineStorage.set("topics", response.data);
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
      });
  },
  saveQuestion(context, payload) {
    mutations.clearErrors();
    // Convert the Vue object payload to a simple JS Object
    var data = Object.assign({}, payload);
    // Clean the topic model to include just the id
    data["topic"] = data.topic.id;
    return authHTTP
      .patch("questions/" + data.id + "/", data)
      .then(function(response) {
        // Update the question with the new model returned from the server
        Vue.set(state.questions, response.data.id, response.data);
        return true;
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
        return false;
      });
  },
  createQuestion(context, payload) {
    mutations.clearErrors();
    // Convert to a simple Object and clean up the topic field (Int expected)
    var data = Object.assign({}, payload);
    data["topic"] = data.topic.id;
    return authHTTP
      .post("/questions/", data)
      .then(function(response) {
        Vue.set(state.questions, response.data.id, response.data);
        return response.data.id;
      })
      .catch(function(error) {
        let data = handleError(error);
        context.commit("core/setError", data, { root: true });
        return false;
      });
  }
};
const mutations = {
  setTopics(state, payload) {
    state.topics = payload;
  },
  clearErrors() {
    // Remove all errors
    state.error = {};
  },
  setError(state, payload) {
    // Set an individual error
    Vue.set(state.error, payload.label, payload.message);
  },
  clearError(state, payload) {
    // Remove a single error
    Vue.delete(state.error, payload.label);
  },
  filters(state, payload) {
    MutateFilter(state, payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
